import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn';

export function Table({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="overflow-x-auto rounded-stitch-xl border border-stitch-border shadow-stitch-card">
      <table className={cn('min-w-full divide-y divide-stitch-border', className)} {...props}>
        {children}
      </table>
    </div>
  );
}

export function TableHead({
  className,
  ...props
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead className={cn('bg-stitch-surface-2', className)} {...props} />
  );
}

export function TableBody({
  className,
  ...props
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody
      className={cn('divide-y divide-stitch-border bg-stitch-surface', className)}
      {...props}
    />
  );
}

export function TableRow({
  className,
  ...props
}: HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn('transition hover:bg-stitch-surface-2/80', className)}
      {...props}
    />
  );
}

export function TableTh({
  className,
  ...props
}: HTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cn(
        'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-stitch-muted',
        className,
      )}
      {...props}
    />
  );
}

export function TableTd({
  className,
  ...props
}: HTMLAttributes<HTMLTableCellElement>) {
  return (
    <td
      className={cn('whitespace-nowrap px-4 py-3 text-sm text-stitch-fg', className)}
      {...props}
    />
  );
}

/** Stacked rows on small screens (optional companion to Table). */
export function DataList({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <ul className={cn('divide-y divide-stitch-border rounded-stitch-xl border border-stitch-border', className)}>
      {children}
    </ul>
  );
}

export function DataListItem({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <li className={cn('bg-stitch-surface px-4 py-3 text-sm', className)}>
      {children}
    </li>
  );
}
